export default "/images/ic_estafeta.svg?8ae8821511da968f80ca023b83b81348";